import React from "react";
import "./AddNewProductCardDesign.css";

let baseImgFound = false;

function AddNewProductCardDesign(props) {
  const handleImageOrTitleClick = (e) => {
    e.stopPropagation();
    // Call onViewDetails for image/title click
    if (props.onViewDetails) {
      props.onViewDetails();
    }
  };

  const handleAddClick = (e) => {
    // Stop event propagation to prevent card click
    e.stopPropagation();
    
    // Call the update function
    if (props.updtprofun) {
      props.updtprofun();
    }
  };

  const renderImage = () => {
    baseImgFound = false;
    let imageElement = null;

    props.images.forEach((item, index) => {
      if (item.baseImage && !baseImgFound) {
        baseImgFound = true;
        let imgSrc = "";

        if (item.image.startsWith("products") || item.image.startsWith("mob")) {
          imgSrc = "https://s3.toolsvilla.com/" + item.image;
        } else {
          imgSrc = "https://s3.toolsvilla.com/" + item.image.substr(41);
        }

        imageElement = (
          <div className="product-image-container" onClick={handleImageOrTitleClick}>
            <img
              src={imgSrc}
              className="product-image"
              alt={props.productName}
              loading="lazy"
            />
          </div>
        );
      }
    });

    return imageElement;
  };

  const renderActionButton = () => {
    // check if it attribute product SL-1143
    if (
        props.vendors &&
        props.vendors[0] !== null && (props.vendors[0].combination && props.vendors[0].combination.length > 0)
      ) {
      if (props.isAllcomb || props.isAllCombReqApprov) {
        return (
          <button className="action-button btn-added" disabled>
            <i className="bi bi-check-circle-fill"></i>
            <span>Already Added</span>
          </button>
        );
      } else if (props.isPend || props.isAllCombReqPend) {
        return (
          <button className="action-button btn-pending" disabled>
            <i className="bi bi-clock-history"></i>
            <span>Pending Approval</span>
          </button>
        );
      } else {
        return (
          <button className="action-button btn-add pushable" onClick={handleAddClick}>
            <span className="shadow"></span>
            <span className="front">
              <i className="bi bi-plus-circle"></i>
              <span>Add Product</span>
            </span>
          </button>
        );
      }
    } else {
      if (props.vendors && props.vendors[0] !== null && props.vendors[0].vActive === "ACTIVE") {
        // Fully approved
        return (
          <button className="action-button btn-added" disabled>
            <i className="bi bi-check-circle-fill"></i>
            <span>Already Added</span>
          </button>
        );
      } else if (
        props.vendors &&
        props.vendors[0] !== null &&
        props.vendors[0].vActive != "ACTIVE"
        // (props.vendors[0].purchase_price || 
        // (props.vendors[0].combination && props.vendors[0].combination.length > 0))
      ) {
        // Has price/combination set but not yet ACTIVE = pending approval
        return (
          <button className="action-button btn-pending" disabled>
            <i className="bi bi-clock-history"></i>
            <span>Pending Approval</span>
          </button>
        );
      } else {
        return (
          <button className="action-button btn-add pushable" onClick={handleAddClick}>
            <span className="shadow"></span>
            <span className="front">
              <i className="bi bi-plus-circle"></i>
              <span>Add Product</span>
            </span>
          </button>
        );
      }
    }
  };

  return (
    <div className="tv-product-card-wrapper">
      <div className="product-card">
        {renderImage()}

        <div className="product-details">
          {/* Row 1: Category and Subcategory */}
          {/* props.categoryName && (
            <div className="category-row">
              <span className="category-badge">{props.categoryName}</span>
              {props.subcategoryName && (
                <span className="subcategory-text">{props.subcategoryName}</span>
              )}
            </div>
          )*/}

          {/* Row 2: Product Name (Bold) - Clickable */}
          <h3 className="product-title" onClick={handleImageOrTitleClick} style={{ cursor: 'pointer' }}>
            {props.productName}
          </h3>

          {/* Row 3: SKU instead of Description */}
          {props.showSKU && props.SKU && (
            <div className="product-sku-display">
              SKU: <span className="sku-value-inline">{props.SKU}</span>
            </div>
          )}

          {/* Show description only if showSKU is false */}
          {!props.showSKU && props.shortDescription && (
            <div className="product-description" dangerouslySetInnerHTML={{ __html: props.shortDescription }} />
          )}

          {/* Row 4: Price (Left) and Add Button (Right) - Only show if hidePrice is false */}
          {!props.hidePrice && (
            <div className="price-action-row">
              {props.price && (
                <div className="price-section">
                  <div className="price-label">Base Price</div>
                  <div className="price-amount">₹{props.price}</div>
                </div>
              )}
              <div onClick={(e) => e.stopPropagation()}>
                {renderActionButton()}
              </div>
            </div>
          )}

          {/* If hidePrice is true, show only the button */}
          {props.hidePrice && (
            <div className="action-only-row">
              <div onClick={(e) => e.stopPropagation()}>
                {renderActionButton()}
              </div>
            </div>
          )}

          {/* Row 5: Brand */}
          {props.manufacturerName && (
            <div className="brand-row">
              <div className="brand-section">
                <span className="brand-label">Brand:</span>
                <span className="brand-name">{props.manufacturerName}</span>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default AddNewProductCardDesign;